import Vue from 'vue';
import SubMenu from '../../components/common/sub-menu.vue';
// https://www.npmjs.com/package/vue-recaptcha
import VueRecaptcha from 'vue-recaptcha';

// https://docs.sentry.io/platforms/javascript/vue/
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

// https://github.com/vuejs-tips/vue-the-mask
import VueTheMask from 'vue-the-mask';

// https://github.com/dansmaculotte/vue-zendesk
import Zendesk from '@dansmaculotte/vue-zendesk';

const dsn = process.env.VUE_APP_SENTRY;

if (dsn) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY,
    integrations: [ new Integrations.Vue({ Vue, attachProps: true }) ],
    ignoreErrors: ['ResizeObserver loop limit exceeded']
  });

  Sentry.setTag('ambiente', process.env.NODE_ENV);
}

Vue.component('VueRecaptcha', VueRecaptcha);
Vue.component('SubMenu', SubMenu);
Vue.component('Chart', (resolve) => require(['components/common/chart'], resolve));
Vue.component('SumoSelect', (resolve) => require(['components/common/sumoSelect'], resolve));
Vue.component('Multiselect', (resolve) => require(['components/common/multiSelect/MultiSelect'], resolve));

Vue.use(VueTheMask);
Vue.use(Zendesk, {
  key: process.env.VUE_APP_ZENDESK_KEY,
  disabled: process.env.NODE_ENV !== 'production', // habilita se for production
  hideOnLoad: true,
  settings: {
    webWidget: {
      helpCenter: {
        suppress: false
      },
      chat: {
        suppress: false
      },
      contactForm: {
        suppress: false
      },
      color: {
        theme: '#ffffff',
        launcher: '#f27220',
        launcherText: '#ffffff',
        button: '#3c454f',
        resultLists: '#3c454f',
        header: '#3c454f',
        articleLinks: '#3c454f',
        bypassAccessibilityRequirement: true
      },
      authenticate: {
        chat: {
          jwtFn: function (callback) {
            R.Chat.zendeskToken().then((result) => {
              if (result.data) {
                callback(result.data);
              }
            });
          }
        }
      }
    }
  }
});
